export default "__VITE_ASSET__22245c31__"